import { FC } from 'react';

import justdoneConfig from '~/projects/justdone/config';
// eslint-disable-next-line import/no-unresolved
import polyllmChatConfig from '~/projects/polyllm-chat/config';
import sidekickerConfig from '~/projects/sidekicker/config';
import { ProjectConfigType } from '~/projects/types';

export enum PROJECT {
  'JUSTDONE' = 'justdone',
  'SIDEKICKER' = 'sidekicker',
  'POLYLLM_CHAT' = 'polyllm-chat',
}

type ConfigType = {
  project: PROJECT;
  getProjectName(): string;
  getBigLogo(): FC<{ className?: string }>;
  getSupportEmail(): string;
};

class Config implements ConfigType {
  private projectsConfigs: Record<PROJECT, ProjectConfigType> = {
    [PROJECT.JUSTDONE]: polyllmChatConfig,
    [PROJECT.SIDEKICKER]: sidekickerConfig,
    [PROJECT.POLYLLM_CHAT]: polyllmChatConfig,
  };
  public project: PROJECT;
  constructor(project: PROJECT) {
    this.project = project;
  }

  getProjectName(): string {
    return this.projectsConfigs[this.project].name;
  }

  getLogo(): FC<{ className?: string }> {
    return this.projectsConfigs[this.project].getLogo();
  }

  getBigLogo(): FC<{ className?: string }> {
    return this.projectsConfigs[this.project].getBigLogo();
  }

  getSendIcon(): FC<{ className?: string }> {
    return this.projectsConfigs[this.project].getSendIcon();
  }

  getSupportEmail(): string {
    return this.projectsConfigs[this.project].supportEmail;
  }

  getIsExtensionAvailable(): boolean {
    return this.projectsConfigs[this.project].isExtensionAvailable;
  }

  checkIsToolAvailable(id: string): boolean {
    const availableToolIds =
      this.projectsConfigs[this.project]?.availableToolIds || [];

    if (availableToolIds.length) {
      return availableToolIds.includes(id);
    }
    return true;
  }
}

const projectConfig = new Config(
  (process.env.PROJECT as PROJECT) || PROJECT.JUSTDONE,
);

export default projectConfig;
